import React from "react";
import { TodoContext } from "../TodoContext";
function Form (){
    const{
        addTodo,
        setOpenModal,
    } = React.useContext(TodoContext);
    const [newTodoValue, setNewTodoValue] = React.useState('');

    const onSubmit = (event)=> {
        event.preventDefault();
        addTodo(newTodoValue)
        setOpenModal(false);
    }

    const onChange = (event) =>{
        setNewTodoValue(event.target.value);
    }

    const onCancel = ()=>{
        setOpenModal(false);
    }

    return(
        <form className="taskApp__formContainer" onSubmit={onSubmit}>
            <textarea className="taskApp__form" placeholder="Añade una nueva tarea" value={newTodoValue}
            onChange={onChange}/>
            <div className="taskApp__formButtonContainer">
                <button type="button" className="taskApp__formButton taskApp__formButton--cancelar" onClick={onCancel}> Cancelar </button>
                <button type="submit" className="taskApp__formButton"> Añadir </button>
            </div>
        </form>

    )

}

export { Form };